webpackJsonp([263791100135453],{

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  font-size: 18px;\n  text-align: justify;\n"], ["\n  display: flex;\n  flex-direction: column;\n  font-size: 18px;\n  text-align: justify;\n"]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(34);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(42);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(25);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(
	      "p",
	      null,
	      "I'm a Computer Engineer currently doing a master's degree at",
	      " ",
	      _react2.default.createElement(
	        "a",
	        { href: "https://www.ece.utoronto.ca", target: "_blank" },
	        "UofT"
	      ),
	      ". I use this website to share my thoughts and showcase my work. You can contact me through email: falmusha at gmail"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "I'm also interested in photography. Check it out",
	      " ",
	      _react2.default.createElement(
	        "a",
	        { href: "https://500px.com/ifahad7", target: "_blank" },
	        "here"
	      ),
	      "."
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-4bb336bfaa20c483d273.js